const stagingAppConfig = {
  REACT_APP_HOST_URL: "http://localhost:4200/",
  REACT_APP_DEPLOYMENT_URL: "https://staging-gamification-portal.dsquares.com",
  REACT_APP_API_URL: "https://gamification-middleware-staging.dsquares.com/gamification-middleware",
  REACT_APP_MAGICO_URL: "https://elmagico-staging.dsquares.com",
  REACT_APP_GA_ID: "G-XC5LPGEY2Q",
  REACT_APP_CLARITY_ID: "u6ytsy15rg",
  DEFAULT_PROGRAME_KEY: "9e652f12-2c9e-4bfa-962e-078b82733a1a",
};

const preprodAppConfig = {
  REACT_APP_DEPLOYMENT_URL: "https://preprod-gamification-portal.dsquares.com",
  REACT_APP_API_URL: "https://gamification-middleware-preprod.dsquares.com/gamification-middleware",
  REACT_APP_MAGICO_URL: "https://elmagico.dsquares.com",
  REACT_APP_GA_ID: "",
  REACT_APP_CLARITY_ID: "ulws2zdq0b",
  DEFAULT_PROGRAME_KEY: "e2fc714c-4727-4d5a-9b1e-9f9272c88a4e",
};

const prodAppConfig = {
  REACT_APP_DEPLOYMENT_URL: "https://gamification-portal.dsquares.com",
  REACT_APP_API_URL: "https://gamification-middleware.dsquares.com/gamification-middleware",
  REACT_APP_MAGICO_URL: "https://elmagico.dsquares.com",
  REACT_APP_GA_ID: "",
  REACT_APP_CLARITY_ID: "",
  DEFAULT_PROGRAME_KEY: "",
};

export const appConfig = {
  staging: stagingAppConfig,
  preproduction: preprodAppConfig,
  production: prodAppConfig,
};

export const env = (process.env.DEPLOYMENT_ENV || "staging") as keyof typeof appConfig;

export const currentConfig = appConfig[env];

export const TAG_TYPES = ["localized", "magico-app-config"];
